import React from 'react';
import { DropdownTooltipText } from '@instinet-analytics/semantic-ui-components';
import preview1 from './eventsWidgetPreviews.png';
import preview2 from './eventsWidgetPreviews2.png';
import preview3 from './eventsWidgetPreviews3.png';
import preview4 from './eventsWidgetPreviews4.png';

export const corporateActionsDescription: DropdownTooltipText = {
    body: (
        <>
            <div>
                The Events widget displays historical and upcoming corporate
                actions and holidays for a given symbol. These include
                delistings, new listings, cash and stock dividends, equity
                offerings, rights offers, spin offs, stock splits, ID, listing,
                name and RLOT changes as well as earnings releases.
            </div>
            <div>
                Use the layout manager to select from global layouts which have
                been configured with columns and filters appropriate for
                corporate actions and holidays.
            </div>
        </>
    ),
    minPreviewHeight: 180,
    previews: [
        {
            src: preview1,
            altText: 'events-preview',
        },
        {
            src: preview2,
            altText: 'events-preview-corporate-actions-layout',
        },
        {
            src: preview3,
            altText: 'events-preview-holidays-layout',
        },
        {
            src: preview4,
            altText: 'events-preview-layouts',
        },
    ],
};
